import styled from '@emotion/styled';

const StyledEmpty = styled.div`
  padding: 4px 8px;
  text-align: center;
  color: var(--dk-text-secondary, #888d96);
  font-size: 14px;
  font-weight: 400;
  line-height: 20px; /* 142.857% */
  white-space: pre-line;
  margin-top: 12px;
`;
export { StyledEmpty };
